<div appDialogSelectable appDialogKeyboardEnabled>
  <div
    class="document-edit-text-dialog"
    (cdkDragStarted)="dialogBoundryService.handleDragStart($event)"
    (cdkDragEnded)="dialogBoundryService.handleDragEnd($event)"
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDrag
  >
    <div appDialogDragArea cdkDragHandle></div>
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-header-title">{{ data.title }}</div>
        <div class="modal-buttons">
          <div (click)="close()">
            <img src="/assets/icons/Close White.svg" alt="Close" />
          </div>
        </div>
      </div>

      <div class="modal-content-body">
        <div class="comparison-table">
          <div class="comparison-header">Original text</div>
          <div class="comparison-header">Translated text</div>

          <ng-container *ngFor="let row of comparisonRows">
            <div class="comparison-cell comparison-cell-original">{{ row.originalText }}</div>
            <div class="comparison-cell comparison-cell-translated">{{ row.translatedText }}</div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
